import React, { useEffect } from 'react';
import { Video, Play, Book, Star, Shield, ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Footer } from '../Footer';
import { PublicHeader } from '../PublicHeader';

export function Tutorials() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const tutorials = [
    {
      title: 'Getting Started with BidWin',
      description: 'Learn the basics of using BidWin to find and win government contracts.',
      duration: '10 min',
      level: 'Beginner',
      icon: Book,
      comingSoon: false
    },
    {
      title: 'AI-Powered Proposal Writing',
      description: 'Master the art of generating winning proposals using our AI tools.',
      duration: '15 min',
      level: 'Intermediate',
      icon: Star,
      comingSoon: true
    },
    {
      title: 'Advanced Contract Matching',
      description: 'Deep dive into contract matching algorithms and optimization.',
      duration: '20 min',
      level: 'Advanced',
      icon: Shield,
      comingSoon: true
    }
  ];

  return (
    <div className="min-h-screen flex flex-col bg-bw-app">
      <PublicHeader />
      
      <div className="flex-grow">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="relative bg-bw-sidebar rounded-lg shadow-lg p-12 mb-12 overflow-hidden">
            <div className="absolute inset-0 opacity-10">
              <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff_1px,transparent_1px),linear-gradient(to_bottom,#ffffff_1px,transparent_1px)] bg-[size:4rem_4rem]"></div>
            </div>
            
            <div className="relative text-center text-white">
              <div className="flex items-center justify-center mb-6">
                <Video className="h-12 w-12 text-bw-accent" />
              </div>
              <h1 className="text-4xl font-bold mb-4">Video Tutorials</h1>
              <p className="text-white/90 max-w-2xl mx-auto">
                Step-by-step video guides to help you master BidWin's features and win more contracts.
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {tutorials.map((tutorial) => (
              <div
                key={tutorial.title}
                className="bg-bw-surface rounded-xl shadow-lg overflow-hidden transform hover:scale-[1.02] transition-all duration-300"
              >
                <div className="relative bg-bw-sidebar p-8">
                  <div className="absolute inset-0 opacity-10">
                    <div className="absolute inset-0 bg-[linear-gradient(to_right,#ffffff_1px,transparent_1px),linear-gradient(to_bottom,#ffffff_1px,transparent_1px)] bg-[size:4rem_4rem]"></div>
                  </div>
                  
                  <div className="relative">
                    <tutorial.icon className="h-8 w-8 text-white mb-4" />
                    <h3 className="text-xl font-bold text-white">{tutorial.title}</h3>
                  </div>
                </div>

                <div className="p-6">
                  <p className="text-bw-muted mb-4">{tutorial.description}</p>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center text-sm text-bw-muted">
                      <Play className="h-4 w-4 mr-1" />
                      {tutorial.duration}
                    </div>
                    <span className="text-sm text-bw-primary bg-bw-primary-tint px-2 py-1 rounded-full">
                      {tutorial.level}
                    </span>
                  </div>
                  {tutorial.comingSoon ? (
                    <div className="mt-4 text-center py-2 bg-bw-surface-subtle rounded-lg">
                      <span className="text-sm font-medium text-bw-muted">Coming Soon</span>
                    </div>
                  ) : (
                    <button className="mt-4 w-full flex items-center justify-center px-4 py-2 bg-bw-primary text-white rounded-lg hover:bg-bw-primary/90 group">
                      Watch Tutorial
                      <ChevronRight className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform" />
                    </button>
                  )}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 bg-bw-surface rounded-lg shadow-lg p-8 text-center">
            <div className="flex items-center justify-center text-bw-primary mb-4">
              <Shield className="h-8 w-8" />
            </div>
            <h3 className="text-lg font-medium text-bw-ink mb-2">
              More Tutorials Coming Soon
            </h3>
            <p className="text-bw-muted">
              We're creating new tutorials to help you make the most of BidWin. Check back regularly for updates.
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}